import React, {useEffect, useRef, useState} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import Select from 'react-select'
import {DEFAULT_VAT_TYPE, VAT_TYPE_NONE, VAT_TYPE_OPTIONS} from '../../constants/Common'
import {reactSelectValue} from '../../utils/Helper'
import {useSearchParams} from 'react-router-dom'

interface IFormVatType {
  locked?: boolean
  previousVatType?: string
  disabledIssueTax?: boolean
  isExpense?: boolean
  onChange(data: any): void
  currentDocumentForm?: any
  currentRelateDocument?: any
}

const FormVatType: React.FC<IFormVatType> = (props) => {
  const [searchParams] = useSearchParams()
  const paymentId = searchParams.get('paymentId')
  const [init, setInit] = useState(false)
  const hasItemWithTax = props?.currentDocumentForm?.items?.some((item: any) =>
    [0, 7].includes(item.vat)
  )
  const hasIssueTaxInvoiceBefore = props?.currentRelateDocument?.issueTaxInvoice
  const vatTypeInitialized = useRef(false)
  // เริ่มจากค่าที่หน้าเอกสารส่งมา ไม่ใช่ค่าเริ่มต้นเสมอ: หน้าใบลดหนี้/เพิ่มหนี้โหลดเอกสารต้นทางก่อนช่องนี้ขึ้น
  // ถ้าเริ่มที่ค่าเริ่มต้น ตัวนี้กับหน้าเอกสารจะส่งค่าของตัวเองให้กันสลับไปมาไม่หยุด (ประเภทราคากระพริบ)
  const [form, setForm] = useState({
    vatType: props.previousVatType || DEFAULT_VAT_TYPE,
    issueTaxInvoice: 0,
    expenseIssueTaxInvoice: 0,
    isUseExpenseIssueTaxInvoice: 0,
    filePpThirty: 0,
  })

  useEffect(() => {
    if (!props.previousVatType) return

    const vatType = props.previousVatType
    setForm((prev) => ({...prev, vatType}))
  }, [props.previousVatType])

  useEffect(() => {
    if (vatTypeInitialized.current) return
    if (!props.currentDocumentForm?.code) return // รอจน API load แล้ว (code จะมีค่าหลังจาก fetch เสร็จ)

    vatTypeInitialized.current = true
    // sync internal state จากค่าที่ parent hydrate ตอน edit เพื่อไม่ให้ onChange ส่ง 0 ทับค่าที่โหลดมา
    // expenseIssueTaxInvoice เป็น tri-state (null/0/1) — ต้องคง null ไว้ ห้าม coerce เป็น 0
    setForm((prev) => ({
      ...prev,
      filePpThirty: props.currentDocumentForm.filePpThirty ?? 0,
      expenseIssueTaxInvoice: props.currentDocumentForm.expenseIssueTaxInvoice ?? null,
      isUseExpenseIssueTaxInvoice: props.currentDocumentForm.isUseExpenseIssueTaxInvoice ?? 0,
    }))
  }, [
    props.currentDocumentForm?.filePpThirty,
    props.currentDocumentForm?.expenseIssueTaxInvoice,
    props.currentDocumentForm?.isUseExpenseIssueTaxInvoice,
    props.currentDocumentForm?.code,
  ])

  useEffect(() => {
    props.onChange(form)
  }, [form])

  useEffect(() => {
    setTimeout(
      () => {
        setForm((prev: any) => {
          return {
            ...prev,
            issueTaxInvoice: !hasIssueTaxInvoiceBefore && hasItemWithTax ? 1 : 0,
          }
        })

        if (!init) {
          setInit(true)
        }
      },
      init ? 100 : 400
    )
  }, [init, hasItemWithTax])

  const isExpenseChecked = props?.currentDocumentForm?.expenseIssueTaxInvoice
  const isUseExpenseChecked = props?.currentDocumentForm?.isUseExpenseIssueTaxInvoice

  return (
    <div>
      <Row>
        <Col md={4}>
          <Form.Group className='mb-5' controlId={'vatType'}>
            <Form.Label>ประเภทราคา</Form.Label>
            <Select
              isDisabled={props.locked || Boolean(paymentId)}
              classNamePrefix='react-select'
              options={VAT_TYPE_OPTIONS}
              name={'vatType'}
              value={reactSelectValue(VAT_TYPE_OPTIONS, form.vatType)}
              onChange={(opt, action) => {
                setForm({
                  ...form,
                  vatType: opt.value,
                  issueTaxInvoice: opt.value === 'none' ? 0 : form.issueTaxInvoice,
                })
              }}
            />
          </Form.Group>
        </Col>
        {props?.isExpense ? (
          <Col md={4}>
            <Form.Group controlId={'expenseIssueTaxInvoice'}>
              <Form.Label>การออกใบกำกับภาษี</Form.Label>
              <Form.Check
                type='switch'
                id='custom-switch'
                label='ออกใบกำกับภาษี'
                disabled={form.vatType === VAT_TYPE_NONE || !Boolean(isUseExpenseChecked)}
                className={'form-check-custom form-switch-xs'}
                checked={Boolean(isExpenseChecked)}
                onChange={(e) => {
                  const value = Number(e.target.checked)
                  // console.log(999999999, {value})

                  setForm({
                    ...form,
                    expenseIssueTaxInvoice: value,
                  })
                }}
              />
            </Form.Group>

            <Form.Group controlId={'isUseExpenseIssueTaxInvoice'}>
              <Form.Check
                type='switch'
                label='ใช้ใบกำกับภาษี'
                disabled={form.vatType === VAT_TYPE_NONE}
                className={'form-check-custom form-switch-xs mt-2'}
                checked={Boolean(isUseExpenseChecked)}
                onChange={(e) => {
                  const value = Number(e.target.checked)
                  // console.log(999999999, {value})

                  setForm({
                    ...form,
                    isUseExpenseIssueTaxInvoice: value,
                    ...(!value && {expenseIssueTaxInvoice: value}),
                  })
                }}
              />
            </Form.Group>
          </Col>
        ) : (
          <>
            {!props.disabledIssueTax && (
              <Col md={4}>
                <Form.Group controlId={'issueTaxInvoice'}>
                  <Form.Label>การออกใบกำกับภาษี</Form.Label>
                  <Form.Check
                    disabled={hasIssueTaxInvoiceBefore || !hasItemWithTax}
                    type='switch'
                    id='custom-switch'
                    label='ออกใบกำกับภาษี'
                    className={'form-check-custom form-switch-xs'}
                    checked={Boolean(form.issueTaxInvoice)}
                    onChange={(e) => {
                      const value = Number(e.target.checked)
                      setForm({
                        ...form,
                        vatType: value === 1 && form.vatType === 'none' ? 'excluded' : form.vatType,
                        issueTaxInvoice: value,
                      })
                    }}
                  />
                </Form.Group>
                <Form.Group controlId={'filePpThirty'}>
                  <Form.Check
                    type='switch'
                    id='filePpThirty-switch'
                    label='ยื่นรับรู้รายได้ ภ.พ. 30'
                    className={'form-check-custom form-switch-xs'}
                    checked={Boolean(props?.currentDocumentForm?.filePpThirty ?? form.filePpThirty)}
                    onChange={(e) => {
                      setForm({...form, filePpThirty: Number(e.target.checked)})
                    }}
                  />
                </Form.Group>
              </Col>
            )}
          </>
        )}
      </Row>
    </div>
  )
}

export default FormVatType
